/**
 * The WhatsApp (QR) number a chat belongs to. A QR chat is tied to exactly one number from the moment it exists
 * (a contact's own `connectionId`, a group's own number), so there is nothing to choose when replying -- this only
 * looks the number up so the composer can show that number's own state (disconnected / resting / daily cap).
 *
 *   - a group   -> groupInfo.connectionId
 *   - a contact -> contactInfo.connectionId, or the inbox card's
 * Returns `{ connection, connections }`: the entry of the workspace's `whatsappQrConnections` (state, label, burstPauseUntil,
 * dailyLimitReached ...), or null when the chat has no known number or the workspace has no QR numbers; and that whole list, so a caller can
 * tell "this chat's number is unknown" from "the workspace has one number" (see utils/qrNumberState.js composerQrState).
 */
import { useSelector } from "react-redux";
import { findInboxCard } from "../../../utils/findInboxCard";

export function useChatQrNumber({ threadId, isGroup }) {
  const connections = useSelector((s) => s.workspace?.currentWorkspace?.whatsappQrConnections);
  const connectionId = useSelector((s) => {
    if (isGroup) return s.inboxInfo?.groupInfo?.connectionId || null;
    if (!threadId) return null;
    const info = s.inboxInfo?.contactInfo;
    if (info && String(info._id) === String(threadId) && info.connectionId) return info.connectionId;
    // Any inbox list that holds the chat, not `All` alone: a closed chat is only in `Closed`.
    return findInboxCard(s.inboxRecent?.data, threadId)?.connectionId || null;
  });
  const connection = Array.isArray(connections) && connectionId ? connections.find((c) => c.connectionId === String(connectionId)) || null : null;
  return { connection, connections };
}

export default useChatQrNumber;
